import { useEffect, useRef } from "react";
import { PDFDocument } from "pdf-lib";

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
export const copy = (object) => JSON.parse(JSON.stringify(object));

export const commafy = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const filterFalsy = (x) =>
  Object.entries(x).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {});

export const url_encode = (val) => encodeURIComponent(JSON.stringify(val));

export const url_decode = (val) => JSON.parse(decodeURIComponent(val));

export const keyfy = (key) =>
  key
    .split("")
    .reduce((acc, curr) => {
      let char = "";
      if (acc.length === 0 && curr !== curr.toUpperCase()) {
        char = curr.toUpperCase();
      } else if (
        acc.length > 0 &&
        curr === curr.toUpperCase() &&
        curr !== " " &&
        acc[acc.length - 1] !== " "
      ) {
        char = " " + curr;
      } else {
        char = curr;
      }
      acc.push(char);
      return acc;
    }, [])
    .join("");

//adds 5% ammount to the real book amount
export const addAmount = (itemCost, amounts) => {
  let price = itemCost * (parseInt(amounts.owner_amount) / 100);
  return +price + +itemCost;
};

//adds 8% ammount to the real book amount
export const addAmountMem = (itemCost, amounts) => {
  let price =
    itemCost * (parseInt(amounts.owner_amount + amounts.member_amount) / 100);
  return +price + +itemCost;
};

export const getTax = (amounts, item, type) => {
  let tax = parseFloat(
    (item.price[type] * (parseInt(amounts?.tax) / 100)).toFixed(2)
  );
  return tax;
};

export const pageCount = async (book) => {
  const formUrl = book.pdf_file;
  const formBytes = await fetch(formUrl).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(formBytes);
  const pages = pdfDoc.getPageCount();
  return pages;
};

export const addDate = () => {
  var date = new Date();
  var expiryDate = date.setDate(date.getDate() + 30);
  return new Date(expiryDate)
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");
};

export const fillArrayRandom = (value, len) => {
  var arr = [];
  for (var i = 0; i < len; i++) {
    const random = value[Math.floor(Math.random() * value.length)];
    if (random) {
      arr.push(random);
    } else {
      console.log("Random ad is undefined at index", i);
    }
  }
  console.log("Filled array (random):", arr);
  return arr;
};

export const fillArray = (value, len) => {
  var arr = [];
  for (var i = 0; i < len; i++) {
    if (value) {
      arr.push(value);
    } else {
      console.log("Value is undefined at index", i);
    }
  }
  console.log("Filled array:", arr);
  return arr;
};

export function containsImg(target) {
  const pattern = ["jpeg", "jpg", "png", "webp", "gif", "psd", "svg"];
  var value = 0;
  pattern.forEach(function (word) {
    value = value + target.includes(word);
  });
  return value === 1;
}

export const navigateUrl = (url) => {
  let element = document.createElement("a");
  element.target = "_blank";
  if (url.startsWith("http://") || url.startsWith("https://")) {
    element.href = url;
  } else {
    element.href = "http://" + url;
  }

  element.click();
};

export const getSize = async (file) => {
  debugger
  const formUrl = file;
  const formBytes = await fetch(formUrl).then((res) => res.arrayBuffer());
  const pdfDoc = await PDFDocument.load(formBytes);
  const pages = pdfDoc.getPages();
  // Get the width and height of the page
  const size = pages[0].getSize();
  const widthInInches = size.width / 72;
  const heightInInches = size.height / 72;
  const height = heightInInches.toFixed(2);
  const width = widthInInches.toFixed(2);
  if (width == 7.0 && height == 10.0) {
    return true; // Executive "0700X1000"
  }
  if (width >= 8.26 && width < 8.28 && height == 11.69) {
    return true; //A4 "0827X1169"
  } else if (width == 8.5 && height == 11.0) {
    return true; //US Letter "0850X1100"
  } else {
    return false;
  }
};
